import * as React from 'react'
import { Provider } from 'react-redux'
import configureStore from '../store/configureStore'
import ReferencesApp from './ReferencesApp'
import { ReferencesAppState } from '../store/references'

let preloadedState: ReferencesAppState = {
    isLoading:              false,
    showFilter:             false,
    error:                  null,
    page:                   1,

    references:             [],
    lastPage:               0,

    referenceCategories:    [],
    years:                  [],

    selectedYears:          [],
    selectedCategoriesIds:  []
}

const store = configureStore( preloadedState )

export default class Root extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <div className='content'>
                    <div className='container'>
                        <ReferencesApp />
                    </div>
                </div>
            </Provider>
        )
    }
}


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/containers/Root.tsx
 **/